// extracted by mini-css-extract-plugin
export default {"shadowed":"Navbar_shadowed__t9Fe7","active":"Navbar_active__zX0u0","link":"Navbar_link__MqGXJ"};